module.exports = __webpack_public_path__ + "static/img/KK-1.f8467fd5.png";